module.exports = __webpack_public_path__ + "img/undraw_Around_the_world_re_n353.8d4fbc44.svg";